export const defaultColumnMinWidth = 150;
export const checkboxColumnWidth = 40;
export const defaultFixedWidth = 150;